import { TooltipBlack } from "../Tooltip/TooltipBlack/TooltipBlack"
import "./OptionsExecutor.scss"

const ExecutorPlaceholder = ({
    name = '',
    color = false,
    email = '',
    iconStyle = {},
    hideTooltip = false,
    bkg = false,
    isShowInfo = false,
    role_id = false,
    role_name = ''
}) => {

    if (typeof name !== 'string') {
        console.error(`Неверный тип параметра {name} для компонента ExecutorPlaceholder`);
        return (
            <TooltipBlack
                child={
                    <div className='executor-placeholder'>
                        <p>{'-'}</p>
                    </div>
                }
                text={'Ошибка данных'}
            />
        )
    }

    return (
        <>
            {
                isShowInfo ?
                    <div className='executor-placeholder__item'>
                        <div style={{
                            backgroundColor: bkg ? bkg : color, ...iconStyle
                        }} className='executor-placeholder' >
                            <p className="executor-placeholder__text">
                                {name?.length > 0 ? name?.split(' ').map(str => str[0]).reduce((acc, current) => acc += current, '')?.toUpperCase()?.slice(0, 2) : '-'}</p>
                        </div >

                        <div className='executor-placeholder__info'>
                            <div className='executor-placeholder__name-row'>
                                <p className="executor-placeholder__name">{name}</p>
                            </div>
                            {role_name && <span className="executor-placeholder__role">{role_name}</span>}
                            <p className="executor-placeholder__email">{email}</p>
                        </div>
                    </div>

                    :

                    <TooltipBlack
                        hideTooltip={hideTooltip}
                        child={
                            <div style={{
                                backgroundColor: bkg ? bkg : color, ...iconStyle
                            }} className='executor-placeholder' >
                                <p className="executor-placeholder__text">
                                    {name?.length > 0 ? name?.split(' ').map(str => str[0]).reduce((acc, current) => acc += (current || ''), '')?.toUpperCase()?.slice(0, 2) : '-'}</p>
                            </div >
                        }
                        text={
                            <>
                                <p>{name}</p>
                                <p>{email}</p>
                                {role_name && <p className="tooltip__role">{role_name}</p>}
                            </>
                        }
                    />
            }
        </>
    )
}

const OptionsExecutor = ({ id, name, email, color, img, role_name, onClick }) => {
    return (
        <div
            className='options-executor'
            onClick={() => onClick({ id, name, email, img, color })}
        >
            {img ? <img src={img} /> : <ExecutorPlaceholder name={name} email={email} hideTooltip color={color} />}
            <div className="text-box">
                <div className="text-box__name-row">
                    <p className="text" style={{ textAlign: 'left' }}>{name}</p>
                </div>
                {role_name && <span className="text-box__role">{role_name}</span>}
                <p className="text_grey">{email}</p>
            </div>
        </div>
    )
}

export { OptionsExecutor, ExecutorPlaceholder }